type Props = {
  open: boolean;
  loading?: boolean;
  onNao: () => void;
  onSim: () => void;
};

export function EnviarCozinhaConfirmModal({ open, loading = false, onNao, onSim }: Props) {
  if (!open) return null;

  return (
    <div className="caixa-overlay caixa-overlay--60">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="enviar-cozinha-title"
        className="caixa-modal caixa-enviar-cozinha-modal"
      >
        <h2 id="enviar-cozinha-title" className="caixa-modal-title">
          Enviar para a cozinha?
        </h2>
        <div className="caixa-modal-footer caixa-enviar-cozinha-footer">
          <button
            type="button"
            disabled={loading}
            onClick={onNao}
            className="caixa-btn-danger"
          >
            Não
          </button>
          <button
            type="button"
            disabled={loading}
            onClick={onSim}
            className="caixa-btn-success"
          >
            {loading ? "Salvando…" : "Sim"}
          </button>
        </div>
      </div>
    </div>
  );
}
